import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, Optional, forwardRef } from '@angular/core';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { Events } from '@df/core/service/event';
import { SamplesBasket } from '@df/samples/samples-basket';
import { BasketItem } from '@df/session/api/basket/basket-item';
import { Customer } from '@df/session/api/customer';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { BasketViewItemComponent } from '../../basket/view-item/basket-view-item.component';
import { BasketViewTotalsComponent } from '../../basket/view-totals/basket-view-totals.component';
import { Section1Component } from '../../ui/display/section1/section1.component';
import { CheckoutExpandableComponent } from '../expandable/checkout-expandable.component';
import { CheckoutFormComponent } from '../form/checkout-form.component';
@Component({
    selector: 'checkout-basket-summary',
    templateUrl: './checkout-basket-summary.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CommonModule,
        forwardRef(() => BasketViewTotalsComponent),
        BasketViewItemComponent,
        PriceComponent,
        TranslationModule,
        CheckoutExpandableComponent,
        Section1Component
    ]
})
export class CheckoutBasketSummaryComponent extends UiComponent {
    /**
     * Hides qty selector and remove buttons for items.
     */
    @Input()
    lock?: boolean;

    /**
     * expandable id
     */
    readonly expandableId = ['checkout', 'basket'];
    constructor(
        private customer: Customer,
        private samplesBasket: SamplesBasket,
        @Optional() private checkoutFormComponent: CheckoutFormComponent,
        private events: Events
    ) {
        super();
    }
    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(this.customer.basket.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.samplesBasket.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.checkoutFormComponent?.saveShippingMethodStatus.subscribe(() => this.detectChanges()));
        this.subscriptions.add(this.events.on(Checkout.EVENTS.TotalsUpdate).subscribe(() => this.detectChanges()));
    }
    get basket() {
        return this.isSamples ? this.samplesBasket : this.customer.basket;
    }
    get isSamples(): boolean {
        return this.checkoutFormComponent?.isSamples;
    }
    get title(): string {
        if (this.isSamples) {
            if (this.basket?.totals?.subtotal) {
                return 'Samples';
            } else {
                return 'Free Samples';
            }
        }
        return 'Order summary';
    }
    get samplesSelected(): number {
        return this.basket.items.length;
    }
    itemTrackFn(index: number, item: BasketItem) {
        return item.id;
    }
    get displayShipping(): boolean {
        if (this.selfCollect) {
            return true;
        }
        return this.shippingPrice !== undefined;
    }
    get selfCollect(): boolean {
        return this.checkoutFormComponent?.selfCollect;
    }
    get shippingPrice(): number | undefined {
        const shippingMethod = this.checkoutFormComponent?.shippingMethod;
        if (shippingMethod) {
            if (this.checkoutFormComponent?.saveShippingMethodStatus.busy) {
                return shippingMethod.price;
            }
            return this.basket.data?.totals?.shipping;
        }
        return undefined;
    }
}
